const tr = {
  siteName: "Akkuzey Yapı Malzemeleri",
  siteNameShort: "Akkuzey Yapı",

  // Arayüz metinleri (butonlar, ekran okuyucu etiketleri, boş durum mesajları)
  ui: {
    close: "Kapat",
    back: "Geri",
    previous: "Önceki",
    next: "Sonraki",
    menu: "Menü",
    openMenu: "Menüyü aç",
    closeMenu: "Menüyü kapat",
    logoAlt: "Akkuzey Yapı Malzemeleri",
    dealerLogoAlt: "Bayi logosu",
    whatsapp: "WhatsApp ile yazın",
    productCategories: "Ürün Kategorileri",
    subProducts: "Alt Ürünler",
    subCategoryNotFound: "Alt kategori bulunamadı",
    emptySubCategory: "Bu alt kategoride ürün bulunmamaktadır.",
    code: "Kod",
  },

  homeNavbar: "Anasayfa",
  chooseLanguage: "Dil Seçin",
  products: "Ürünler",
  corporate: "Kurumsal",
  affiliates: "İştiraklerimiz",
  dealerships: "Bayiliklerimiz",
  newsNavbar: "Haberler",
  storesFooter: "Mağazalarımız",
  search_placeholder: "Ürün ara...",
  contactNavbar: "İletişim",
  searchPlaceholder: "Ürün ara...",
  favorites: {
    title: "Favorilerim",
    emptyMessage: "Favori ürününüz bulunmamaktadır.",
  },
  navbar: {
    searching: "Aranıyor…",
    suggestCategories: "Kategoriler",
    suggestProducts: "Ürünler",
    seeAllResults: "Tüm sonuçları gör ({{count}})",
    searchPlaceholder: "Aradığınız ürünün adını yazınız…",
    search: "ARA",
    callUs: "Bizi Arayın",
    myCart: "Sepetim",
    allCategories: "Tüm Kategoriler",
    cats: {
      insaat: "İnşaat Malzemeleri",
      hirdavat: "Hırdavat",
      elAletleri: "El Aletleri",
      boya: "Boya",
      yapiKimyasallari: "Yapı Kimyasalları",
      tesisat: "Tesisat",
      banyo: "Banyo & Armatür",
      elektrik: "Elektrik",
      makinalar: "İnşaat Makinaları",
      kesme: "Kesme & Delme",
    },
  },
  topBanner: {
    message:
      "akkuzey@hotmail.com | +90 537 798 11 29 | İstanbul GMT+3 | Pazartesi-Cumartesi (08:00-20:00) | Pazar (11:00-18:30)",
  },
  subMenus: {
    corporate: {
      about: "Hakkımızda",
      contact: "İletişim",
      qualityPolicy: "Kalite Politikamız",
      complaints: "İstek, Öneri, Şikayet Formu",
      faq: "Sık Sorulan Sorular",
    },
    affiliates: {
      construction: "Akkuzey İnşaat",
      automotive: "Akkuzey Otomotiv",
    },
  },
  home: {
    featuredBrandsEyebrow: "Öne Çıkan Markalar",
    featuredBrandsTitle: "Güvendiğiniz markalar, tek tıkla",
    brandProductCount: "{{count}} ürün",
    newArrivalsEyebrow: "Yeni Eklenenler",
    newArrivalsTitle: "Kataloğa yeni katılan ürünler",
    seeCatalog: "Tüm kataloğu gör",
    viewDetails: "Detayları Gör",
    hero: {
      eyebrow: "1972'den beri yapı malzemeleri",
      title: "Banyodan hırdavata, tek adresten eksiksiz tedarik.",
      subtitle:
        "Akkuzey Yapı, yarım asrı aşkın süredir İstanbul Zeytinburnu'ndan inşaat, tesisat, hırdavat ve banyo–mutfak ürünlerinde toptan ve perakende tedarik sağlıyor.",
      ctaPrimary: "Ürünleri İncele",
      ctaSecondary: "Bize Ulaşın",
      stats: {
        foundedValue: "1972",
        foundedLabel: "Kuruluş",
        dealersValue: "40+",
        dealersLabel: "Yetkili bayilik",
        storesValue: "2",
        storesLabel: "Mağaza · İstanbul",
      },
    },
    brands: {
      title: "Yetkili bayiliklerimiz",
      link: "Tümünü gör",
    },
    wholesale: {
      eyebrow: "Toptan satış",
      title: "Şantiyelere tuğla ve çimento toptan tedarik.",
      subtitle:
        "İnşaat projeleriniz için tuğla, çimento ve temel yapı malzemelerini toptan fiyatlarla doğrudan şantiyenize teslim ediyoruz. Miktar ve teslimat programınıza göre fiyat alın.",
      items: {
        brick: "Tuğla",
        brickNote: "Delikli, dolu ve gaz beton",
        cement: "Çimento",
        cementNote: "Torbalı ve dökme",
        delivery: "Şantiye teslimat",
        deliveryNote: "Proje programına göre sevkiyat",
      },
      ctaPrimary: "Toptan Teklif Alın",
      ctaSecondary: "Hemen Arayın",
      phone: "+90 537 798 11 29",
    },
    cta: {
      title: "Projeniz için doğru malzemeyi birlikte seçelim.",
      subtitle:
        "Ürün, stok ve fiyat bilgisi için bize ulaşın ya da mağazalarımızı ziyaret edin.",
      primary: "Bize Ulaşın",
      secondary: "Mağazalarımız",
    },
    campaigns: {
      showerSets: {
        title: "Duş Setlerinde Yeni Sezon",
        brand: "VitrA · ECA · Creavit",
      },
      paintRollers: {
        title: "Boya Rulo ve Fırçaları",
        brand: "Dekor",
      },
      sealants: {
        title: "Silikon, Mastik ve Montaj Köpükleri",
        brand: "Selsil",
      },
      basinMixers: {
        title: "Lavabo Bataryalarında Geniş Seçenek",
        brand: "ECA · VitrA · Creavit",
      },
      interiorPaints: {
        title: "İç Cephe Boyaları",
        brand: "Filli Boya · Polisan · Marshall",
      },
      bathroomKitchen: {
        title: "Banyo ve Mutfaklarınızda Fark Yaratın",
        brand: "Fark Yaratan Ürünler",
      },
      bathroomAccessories: {
        title: "Banyo Aksesuarları ve Daha Fazlası",
        brand: "İndirimli Fiyatlarla",
      },
      modernAccessories: {
        title: "Modern Aksesuarlar",
        brand: "İndirimli Fiyatlarla",
      },
      bathroomCabinets: {
        title: "Banyo Dolaplarında Yüzlerce Çeşit",
        brand: "Dünyaca Ünlü Markalar",
      },
      selsil: {
        title: "Selsil Hangisi?",
        brand: "Aradığınız",
      },
      sprayPaint: {
        title: "Sprey Boyalarda Yüzlerce Renk!",
        brand: "Maksimum Kalite",
      },
    },
  },
  bathroomAccessories: {
    title: "Banyo Aksesuarları ",

    products: {
      soapDish: "Sabunluk",
      towelHolder: "Havluluk",
      emergencySupportShelf: "Açılı Destekli Raf Havluluk",
      cornerSoapDish: "3 Katlı Beyaz Banyo Köşe Sabunluk",
    },
  },
  bathroomCabinets: {
    title: "Banyo Dolapları",
    products: {
      firdevsSet: "Firdevs Banyo Dolabı Takımı",
      klasikSet: "Klasik Banyo Dolabı Takımı",
      asyaSet: "Asya Banyo Dolabı Takımı",
      quadrumAsma: "Quadrum Asma Banyo Dolabı",
    },
  },
  bathroomKitchen: {
    title: "Banyo ve Mutfak Bataryaları",

    products: {
      begonyaShowerSet: "Begonya Krom Tepe Duş Seti",
      spiralKitchenFaucet: "Spiralli Eviye Bataryası",

      ritaSinkFaucet: "Rita Lavabo Bataryası",
      ritaBathFaucet: "Rita Banyo Bataryası",

      laraBlackSinkFaucet: "Lara Black Lavabo Bataryası",
      laraBlackBathFaucet: "Lara Black Banyo Bataryası",
      alyaSinkFaucet: "Alya Lavabo Bataryası",
      alyaBathFaucet: "Alya Banyo Bataryası",
    },

    barcode: "Barkod",
    code: "Ürün Kodu",
    brand: "Marka",
    color: "Renk",
    colors: {
      chrome: "Krom",
      black: "Siyah",
    },
  },
  stores: {
    title: "Mağazalarımız",
    subtitle:
      "Kaliteli hizmet anlayışımızı yerinde deneyimlemek için mağazalarımızı ziyaret edebilirsiniz.",
    map: "Harita",
    istanbul: {
      city: "İstanbul",
      name: "Ana Şube",
      address: "Çırpıcı, 75/2. Sk. No:109, 34025 Zeytinburnu/İstanbul",
      phone: "+90 537 798 11 29",
      email: "akkuzey@hotmail.com",
      hours: "Pazartesi - Cumartesi: 08:00 - 20:00, Pazar: 11:00 - 18:30",
    },
    ankara: {
      city: "İstanbul",
      name: "Şube",
      address: "Beştelsiz, 1. Yol Sk. No:7, 34020 Zeytinburnu/İstanbul",
      phone: "+90 537 798 11 29",
      email: "akkuzey@hotmail.com",
      hours: "Pazartesi - Cumartesi: 08:00 - 20:00, Pazar: 11:00 - 18:30",
    },
  },
  modernAccessories: {
    title: "Modern Aksesuarlar",
    products: {
      suspendedCeilingPanel: "Akustik Asma Tavan Paneli",
      modernDoorHandleBlack: "Mat Siyah Modern Kapı Kolu",
      modernDoorHandleChrome: "Saten Krom Modern Kapı Kolu",
      sensorSoapDispenser: "Fotoselli Sensörlü Sabunluk",
    },
  },

  selsil: {
    title: "Selsil Ürün Kataloğu",
    barcode: "Barkod",
    code: "Kod",
    brand: "Marka",
    color: "Renk",
    colors: {
      white: "Beyaz",
      black: "Siyah",
      red: "Kırmızı",
      green: "Yeşil",
      blue: "Mavi",
      gray: "Gri",
      lightGray: "Açık Gri",
      transparent: "Şeffaf",
    },
    products: {
      siliconeTransparent: {
        name: "Selsil Genel Amaçlı Silikon 280 Gr Şeffaf",
      },
      siliconeWhite: {
        name: "Selsil Genel Amaçlı Silikon 280 Gr Beyaz",
      },
      siliconeBlack: {
        name: "Selsil Genel Amaçlı Silikon 280 Gr Siyah",
      },
      masticWhite: {
        name: "Selsil Poliüretan Montaj Köpüğü 600 Gr",
      },
      foam600gr: {
        name: "Selsil Poliüretan Montaj Köpüğü 600 Gr 16 Adet 2619",
      },
      rtvHeatSilicone: {
        name: "Selsil X İsi Silikonu Kırmızı 150 Derece 280 Ml",
      },
      puMasticBlack: {
        name: "Selsil Poliüretan PU Mastik 50 SHA 280 ML Siyah",
      },
      miraculouspackage: {
        name: "Selsil Pak Mucize Köpük Temizleyici 500 Ml",
      },
      SelsilCleaning: {
        name: "Selsil Pak Genel Amaçlı Mucize Temizleyici 500 Gr",
      },
      StainRemover: {
        name: "Selsil Pak Leke Çıkarıcı Sprey 150 Ml",
      },
      puMasticGray: {
        name: "Selsil Poliüretan PU Mastik 50 SHA 280 ML Gri",
      },
      puMasticWhite: {
        name: "Selsil Poliüretan PU Mastik 50 SHA 280 ML Beyaz",
      },
      multiPurposeSpray: {
        name: "Selsil PRO Kobra Başlık 400 Ml",
      },
      selsilSprayB: {
        name: "Selsil Rainbow Akrilik Sprey Boya 400 Ml Parlak Kırmızı",
      },
    },
  },
  sprayPaint: {
    title: "Sprey Boya Ürün Kataloğu",
    productName: "Akçalı Sprey Boya 400 Ml {{color}}",
    code: "Kod",
    unit: "ADET",
    category: "Kategori",
    color: "Renk",
    categories: {
      paint: "BOYA",
    },
    colors: {
      white: "Beyaz",
      black: "Siyah",
      red: "Kırmızı",
      green: "Yeşil",
      blue: "Mavi",
      gray: "Gri",
      lightGray: "Açık Gri",
      lightBrown: "Açık Kahve",
      orange: "Turuncu",
      lightGreen: "Açık Yeşil",
      taxiYellow: "Taksi Sarı",
      bordeaux: "Bordo",
      purple: "Mor",
      lightBlue: "Açık Mavi",
      beadBlue: "Boncuk Mavi",
      turquoise: "Turkuaz",
      navyBlue: "Lacivert",
      glossWhite: "Parlak Beyaz",
      beige: "Bej",
      chromeYellow: "Krom Sarı",
      brown: "Kahve",
      glossBlack: "Parlak Siyah",
      matteWhite: "Mat Beyaz",
      matteBlack: "Mat Siyah",
      trafficWhite: "Trafik Beyazı",
      pearlWhite: "İnci Beyazı",
      mossGreen: "Yosun Yeşili",
      anthracite: "Antrasit",
      gloss: "Parlak",
      matte: "Mat",
      saten: "Saten",
      darkGray: "Koyu Gri",
      smoke: "Füme",
      bronze: "Bronz",
      lightAluminium: "Açık Alüminyum",
      mediumGray: "Orta Gri",
      bumperBlack: "Tampon Siyah",
      bumperWhite: "Tampon Beyaz",
      enamelStoveBrown: "Emaye Soba Boyası Kahve",
      metallicBlack: "Metalik Siyah",
      metallicYellow: "Metalik Sarı",
      metallicBlue: "Metalik Mavi",
      grayWhite: "Gri Beyaz",
      oxideYellow: "Oksit Sarı",
      fuchsia: "Fuşya",
      machineRed: "Makina Kırmızısı",
      scarlet: "Kızıl",
      fluorescentYellow: "Floresan Sarı",
      fluorescentLilac: "Floresan Lila",
      fluorescentRed: "Floresan Kırmızı",
      fluorescentDarkRed: "Floresan Koyu Kırmızı",
      fluorescentOrange: "Floresan Kavuniçi",
      plasticPrimer: "Plastik Yüzey Astarı",
    },
    products: {
      akcaliSpray400ml: "AKÇALI SPREY BOYA 400 ml",
      akcaliVarnish400ml: "AKÇALI VERNİK BOYASI 400 ml",
      akcaliBumperPaint400ml: "AKÇALI OTO TAMPON BOYASI 400 ml",
      akcaliWheelPaint400ml: "AKÇALI OTO JANT BOYASI 400 ml",
    },
  },

  dealershipsPage: {
    title: "Bayiliklerimiz",
    subtitle:
      "Akkuzey'in geniş bayi ağı ile ürünlerimize kolayca ulaşabilirsiniz.",
    brands: {
      abb: "ABB",
      armaş: "Armaş",
      baylan: "Baylan",
      ecesan: "Ecesan",
      fluke: "Fluke",
      isonem: "Isonem",
      kalekim: "Kalekim",
      karbon: "Karbon",
      makel: "Makel",
      metoba: "Metoba",
      optimum: "Optimum",
      pelsan: "Pelsan",
      pimtaş: "Pimtaş",
      polisan: "Polisan",
      selsil: "Selsil",
      sista: "Sista",
      viko: "Viko",
      vitra: "Vitra",
      yaparlar: "Yaparlar",
      yds: "YDS",
      alarko: "Alarko",
      askaynak: "Askaynak",
      ayvaz: "Ayvaz",
      beybi: "Beybi",
      bmex: "BMEX",
      bonuspan: "Bonuspan",
      bosh: "Bosch",
      çayırva: "Çayırva",
      dekor: "Dekor",
      dewalt: "Dewalt",
      duyar: "Duyar",
      ebitt: "Ebitt",
      eca: "Eca",
      feica: "Feica",
      fırat: "Fırat",
      honey: "Honeywell",
      kale: "Kale",
      knipex: "Knipex",
      köse: "Köse",
      metresan: "Metresan",
      marshall: "Marshall",
      stanley: "Stanley",
      tekno: "Tekno",
      turkuaz: "Turkuaz",
      pakkens: "Pakkens",
      rothenberg: "Rothenberg",
      sonneflex: "Sonneflex",
      sumak: "Sumak",
      yalteks: "Yalteks",
    },
  },
  product: {
    zoom: "Büyüt",
    close: "Kapat",
    share: "Paylaş",
    linkCopied: "Bağlantı kopyalandı",
    notFound: "Ürün bulunamadı.",
    backToCatalog: "Kataloğa dön",
    options: "Seçenekler",
    askWhatsapp: "WhatsApp'tan Sor",
    whatsappText: "Merhaba, {{ad}}{{secenek}} hakkında fiyat ve stok bilgisi almak istiyorum.",
    call: "Hemen Arayın",
    description: "Ürün Açıklaması",
    autoDescription: "{{ad}}, {{marka}} markasının {{kategori}} grubundaki ürünüdür.",
    optionsSentence: "{{sayi}} farklı seçenekle sunulur: {{liste}}.",
    priceInfo: "Güncel fiyat ve stok bilgisi için WhatsApp'tan ya da telefonla bize ulaşabilirsiniz; toptan alımlarda özel fiyat veriyoruz.",
    metaDescription: "{{ad}} — {{marka}} {{kategori}}. Akkuzey Yapı Malzemeleri'nden fiyat ve stok bilgisi alın.",
    related: "Benzer Ürünler",
    viewAll: "Tümünü gör",
    trust: {
      wholesaleTitle: "Toptan ve Perakende",
      wholesale: "Şantiye ve usta alımlarına özel fiyat",
      sinceTitle: "1972'den Beri",
      since: "Zeytinburnu'nda yapı malzemesi tedariki",
      quoteTitle: "Hızlı Teklif",
      quote: "Sepetinizi WhatsApp'tan tek mesajla gönderin",
    },
  },
  recent: {
    eyebrow: "Kaldığınız yerden",
    title: "Son İncelediğiniz Ürünler",
    clear: "Listeyi temizle",
  },
  calc: {
    materialList: "Malzeme listesi",
    print: "Yazdır / PDF",
    copyLink: "Bağlantıyı kopyala",
    suggested: "Bu iş için önerilen ürünler",
    stepArea: "Alan ve ölçüler",
    stepProduct: "Ürün ve uygulama",
    approx: "yaklaşık",
    tabsHint: {
      boya: "Litre ve kutu",
      duvar: "Adet ve harç",
      seramik: "Kutu, yapıştırıcı, derz",
      beton: "m³ ve çimento",
      alci: "Torba sayısı",
      alcipan: "Levha, profil, vida",
    },
    tile: {
      area: "Döşenecek alan",
      straight: "Düz döşeme (%10 fire)",
      diagonal: "Çapraz döşeme (%15 fire)",
      stepTile: "Seramik ölçüsü",
      tileWidth: "Seramik eni",
      tileHeight: "Seramik boyu",
      thickness: "Seramik kalınlığı",
      boxM2: "Kutudaki alan",
      boxHint: "Kutu etiketinde yazar (ör. 60×60 için 1,44 m²)",
      stepAdhesive: "Yapıştırıcı ve derz",
      adhesive: "Yapıştırıcı sarfiyatı",
      adhesiveHint: "Büyük ebatlarda 5–7 kg/m², küçüklerde 3–4 kg/m²",
      joint: "Derz genişliği",
      result: "Gereken kutu",
      boxes: "kutu",
      tiles: "Seramik",
      adhesiveItem: "Seramik yapıştırıcısı",
      groutItem: "Derz dolgusu",
      browse: "Yapıştırıcıları incele",
      whatsapp: "Merhaba, {{alan}} m² için {{olcu}} cm seramik hesapladım: {{adet}} adet ({{kutu}} kutu), {{torba}} torba yapıştırıcı ve {{derz}} kg derz dolgusu. Fiyat alabilir miyim?",
    },
    concrete: {
      thickness: "Kalınlık",
      type: "Uygulama",
      type_sap: "Şap (tesviye betonu)",
      type_grobeton: "Grobeton (C16)",
      type_c25: "Beton C25",
      type_c30: "Beton C30",
      dosage: "Çimento dozajı",
      dosageHint: "m³ başına çimento; projeye göre değiştirin",
      result: "Gereken çimento",
      cementBags: "torba",
      cement: "Çimento",
      sand: "Kum",
      aggregate: "Kum ve mıcır",
      readyMix: "Hazır beton alırsanız",
      readyMixNote: "sipariş hacmi",
      volume: "Hacim",
      browse: "Çimentoları incele",
      whatsapp: "Merhaba, {{tip}} için {{hacim}} m³ hesapladım: {{torba}} torba ({{kg}} kg) çimento. Fiyat alabilir miyim?",
    },
    drywall: {
      stepSystem: "Duvar sistemi",
      faces: "Kaplanacak yüz",
      oneFace: "Tek yüz",
      twoFaces: "İki yüz",
      layers: "Levha katı",
      single: "Tek kat",
      double: "Çift kat",
      spacing: "Dikme aralığı",
      result: "Gereken levha",
      boards: "levha",
      boardItem: "Alçı levha",
      cProfile: "C profil (dikme)",
      studs: "dikme",
      uProfile: "U profil (taban-tavan)",
      screws: "Alçıpan vidası",
      tape: "Derz bandı",
      jointFiller: "Derz dolgu alçısı",
      browse: "Alçıpan sistemlerini incele",
      whatsapp: "Merhaba, {{alan}} m² alçıpan duvar hesapladım: {{levha}} levha, {{c}} C profil, {{u}} U profil, {{vida}} vida. Fiyat alabilir miyim?",
    },
    eyebrow: "Malzeme Hesaplayıcı",
    title: "Ne kadar malzeme lazım?",
    subtitle: "Ölçüleri girin; boya, tuğla-gazbeton, seramik, beton-şap, alçı ve alçıpan için gereken malzemeyi kalem kalem görün. Listeyi yazdırın ya da tek dokunuşla WhatsApp'tan gönderip fiyat alın.",
    tabs: {
      seramik: "Seramik ve Fayans",
      beton: "Beton ve Şap",
      alcipan: "Alçıpan Duvar",
      boya: "Boya",
      duvar: "Tuğla ve Gazbeton",
      alci: "Alçı ve Sıva",
    },
    askQuote: "Bu miktar için fiyat al",
    disclaimer: "Sonuçlar tahminidir; uygulama yüzeyine ve ürüne göre değişebilir. Kesin miktar için ürün etiketine ya da ustanıza danışın.",
    width: "Genişlik",
    length: "Uzunluk",
    height: "Yükseklik",
    openings: "Kapı / pencere alanı",
    openingsHint: "Boyanmayacak / örülmeyecek alan (düşülür)",
    netArea: "Net alan",
    liter: "litre",
    pieces: "adet",
    waste: "Fire payı",
    wasteHint: "Kırılma ve kesim kaybı için",
    viewProduct: "Ürünü incele",
    paint: {
      item: "Boya",
      primer: "Astar",
      primerNote: "Tek kat, ~12 m²/L",
      addPrimer: "Astar da hesapla",
      mode_oda: "Oda ölçüsüyle",
      mode_alan: "Toplam alanla",
      includeCeiling: "Tavan da boyanacak",
      area: "Boyanacak alan",
      coats: "Kat sayısı",
      coatUnit: "kat",
      coverage: "Sarfiyat",
      coverageHint: "Ürün etiketindeki değer; iç cephe boyalarında genelde 8–12 m²/L",
      result: "Gereken boya",
      packages: "Önerilen ambalaj",
      browse: "Boyaları incele",
      whatsapp: "Merhaba, {{alan}} m² alan için {{kat}} kat boya hesapladım: yaklaşık {{litre}} litre ({{paket}}). Fiyat bilgisi alabilir miyim?",
    },
    wall: {
      mortar: "Örgü harcı",
      thinMortar: "Gazbeton yapıştırma harcı",
      length: "Duvar uzunluğu",
      block: "Tuğla / blok",
      custom: "Ölçüyü kendim gireceğim",
      blockLength: "Blok uzunluğu",
      blockHeight: "Blok yüksekliği",
      joint: "Derz kalınlığı",
      jointHint: "Tuğlada ~10 mm, gazbetonda ince harçla ~3 mm",
      result: "Gereken adet",
      perM2: "m² başına",
      browse: "Tuğla ve gazbetonları incele",
      whatsapp: "Merhaba, {{alan}} m² duvar için {{blok}} hesapladım: yaklaşık {{adet}} adet. Fiyat bilgisi alabilir miyim?",
    },
    plaster: {
      type: "Ürün tipi",
      type_makine: "Makine sıva alçısı",
      type_perlitli: "Perlitli sıva alçısı (elle)",
      type_saten: "Saten perdah alçısı",
      area: "Uygulama alanı",
      thickness: "Kalınlık",
      consumption: "Sarfiyat",
      consumptionHint: "Yaklaşık değer; ürün teknik föyüne göre değiştirin",
      bag: "Torba",
      result: "Gereken torba",
      bags: "torba",
      total: "Toplam",
      bagSize: "Torba ağırlığı",
      browse: "Alçı ve sıvaları incele",
      whatsapp: "Merhaba, {{alan}} m² için {{tip}} ({{kalinlik}} mm) hesapladım: yaklaşık {{torba}} torba ({{kg}} kg). Fiyat bilgisi alabilir miyim?",
    },
    navbarItem: "Hesaplayıcı",
    teaserEyebrow: "Ücretsiz araç",
    teaserTitle: "Ne kadar malzeme lazım, hemen hesaplayın",
    teaserText: "Boya, tuğla-gazbeton ve alçı miktarını ölçülerinizle hesaplayın; sonucu WhatsApp'tan gönderip fiyat alın.",
    teaserCta: "Hesaplamaya başla",
  },
  shop: {
    searchPlaceholder: "Ürün ara…",
    searchAllPlaceholder: "Tüm ürünlerde ara…",
    searchResultsFor: "“{{q}}” için sonuçlar",
    searchNoResult: "Aramanızla eşleşen ürün bulunamadı.",
    brandProducts: "{{marka}} Ürünleri",
    categoryProducts: "Bu kategorideki ürünler",
    cart: "Sepet",
    cartTitle: "Teklif Sepetim",
    cartEmpty: "Sepetiniz boş.",
    cartEmptyHint: "Ürünlerin yanındaki “Sepete Ekle” ile teklif listesi oluşturun.",
    addToCart: "Sepete Ekle",
    added: "Eklendi",
    remove: "Çıkar",
    clear: "Sepeti Boşalt",
    selectSize: "Boyut seçin",
    subCategories: "Alt Kategoriler",
    brands: "Markalar",
    allBrands: "Tümü",
    clearFilters: "Filtreleri temizle",
    productCount: "{{count}} ürün",
    tileZoom: "Görseli incele",
    tileExplore: "İncele",
    noResult: "Bu filtrelerle eşleşen ürün yok.",
    whatsappSend: "WhatsApp ile Teklif İste",
    whatsappIntro: "Merhaba, aşağıdaki ürünler hakkında bilgi ve fiyat almak istiyorum:",
    whatsappOutro: "Teşekkürler.",
    quantity: "Adet",
    productFeatures: {
      "mukemmel-inceltici": "Mükemmel inceltici",
      "su-bazli": "Su bazlı",
      "makinede-renklendirilebilen-beyaz": "Makinede renklendirilebilen beyaz",
      "yuksek-kaplama-alani": "Yüksek kaplama alanı",
      "yuzey-hatalarini-gizler": "Yüzey hatalarını gizler",
      "uzun-omurlu": "Uzun ömürlü",
      "dusuk-koku": "Düşük koku",
      "rahat-uygulama": "Rahat uygulama",
      "lekeleri-gizler": "Lekeleri gizler",
      "yuksek-renk-dayanimi": "Yüksek renk dayanımı",
      "yuksek-ortuculuk": "Yüksek örtücülük",
      "uzun-sureli-beyazlik": "Uzun süreli beyazlık",
      "hizli-kuruyan": "Hızlı kuruyan",
      "tutunmayi-kuvvetlendirir-ve-son-katin-da": "Tutunmayı kuvvetlendirir, son katın dayanımını artırır",
      "kolay-temizlenir": "Kolay temizlenir",
      "leke-dayanimli": "Leke dayanımlı",
      silinebilir: "Silinebilir",
      "pas-onleyici": "Pas önleyici",
      "coklu-yuzeyler-icin": "Çoklu yüzeyler için",
      "hazirlar-korur-ve-guclendirir": "Hazırlar, korur ve güçlendirir",
      "basit-ve-kolay-yuzey-hazirligi": "Basit ve kolay yüzey hazırlığı",
      "astar-gerektirmez": "Astar gerektirmez",
      "guclendirilmis-sizdirmazlik": "Güçlendirilmiş sızdırmazlık",
      "toz-tutmaz": "Toz tutmaz",
      "uzun-sureli-dayanim": "Uzun süreli dayanım",
      "kuf-olusumuna-direncli": "Küf oluşumuna dirençli",
      "ultra-yapisma": "Ultra yapışma",
      "sicratma-ve-damlatma-yapmaz": "Sıçratma ve damlatma yapmaz",
      "uv-dayanikli": "UV dayanıklı",
      "her-turlu-hava-sartlarina-dayanikli": "Her türlü hava şartlarına dayanıklı",
      "scuff-mark-resistant-teknolojisi": "Scuff Mark Resistant teknolojisi",
      "guclu-cizilme-direnci": "Güçlü çizilme direnci",
      "15-kat-daha-fazla-silinebilir": "15 kat daha fazla silinebilir",
      "ultra-yikanabilir": "Ultra yıkanabilir",
      "ultra-kapatici": "Ultra kapatıcı",
      "5-kat-daha-fazla-silinebilir": "5 kat daha fazla silinebilir",
      "kokusuz-ve-cevre-dostu": "Kokusuz ve çevre dostu",
      "smartsil-teknolojisi": "SmartSil teknolojisi",
      yikanabilir: "Yıkanabilir",
      "sicratmaz-kolay-uygulanir": "Sıçratmaz, kolay uygulanır",
    },
  },
  notFound: {
    title: "Aradığınız sayfa bulunamadı.",
    subtitle:
      "Adres değişmiş ya da yanlış yazılmış olabilir. Aşağıdaki bağlantılardan devam edebilirsiniz.",
    home: "Anasayfaya Dön",
  },

  news: {
    title: "Haberler",
    subtitle:
      "Hırdavat ve yapı sektörüyle ilgili en güncel haberleri, sektördeki yenilikleri ve Akkuzey'in basında yer alan gelişmelerini burada bulabilirsiniz.",
    readMore: "Devamını Oku",
    showLess: "Daha Az Göster",
    articles: {
      newTools: {
        title: "Yeni Nesil El Aletleri Piyasaya Sürüldü",
        date: "20 Eylül 2025",
        description:
          "Hırdavat sektöründe çığır açacak yeni nesil el aletleri, ergonomik yapıları ve uzun ömürlü kullanımıyla ustaların beğenisine sunuldu.",
      },
      energyEfficiency: {
        title: "Elektrikli Aletlerde Enerji Verimliliği Dönemi",
        date: "15 Eylül 2025",
        description:
          "Yeni enerji tasarruflu elektrikli aletler, %30 daha az enerji tüketerek maksimum performans sağlıyor. Bu gelişme sektör için devrim niteliğinde.",
      },
      exportRecord: {
        title: "Türkiye'nin Hırdavat İhracatı Rekor Kırdı",
        date: "10 Eylül 2025",
        description:
          "2025'in ilk yarısında Türkiye hırdavat sektörü ihracatta tarihi bir rekora imza attı. Avrupa ve Orta Doğu pazarlarında büyüme dikkat çekiyor.",
      },
      measurementDevices: {
        title: "Akıllı Ölçüm Cihazlarında Yeni Trendler",
        date: "05 Eylül 2025",
        description:
          "Lazerli akıllı ölçüm cihazları, inşaat ve mühendislik alanlarında yüksek doğruluk sağlıyor. Kullanıcı dostu ekranlarıyla sahada işleri hızlandırıyor.",
      },
    },
  },
  qualityPolicy: {
    title: "Kalite Politikamız",
    policies: {
      customerSatisfaction: {
        title: "Müşteri Memnuniyeti",
        description:
          "Kaliteli hizmet sunmak, müşterilerimizin ihtiyaçlarını yerinde anlayıp, en etkin projeleri sunmak, memnuniyetlerini sağlamak öncelikli değerimizdir.",
      },
      reliability: {
        title: "Güvenilirlik",
        description:
          "Doğruluğuna inandığımız iş'te, sektörümüzün önde gelen imalatçı, üreticileri ile çalışarak ve taahhütlerimizi zamanında yerine getirerek, müşterilerimizin ve tedarikçilerimizin güvenini sağlamaktayız.",
      },
      ethicalValues: {
        title: "Etik Değerler",
        description:
          "Dürüst olmak, doğru davranmak, temel prensiplerimizdendir. Açık ve şeffaf olarak, etik kuralları göz ardı etmeyen yönetim tarzını benimseyen, Şirketimizin değerleri arasında; özgüven, dürüstlük, takım ruhu, dayanışma ve topluma duyarlılık yer almaktadır.",
      },
      customerFocus: {
        title: "Müşteri Odaklılık",
        description:
          "Her zaman, müşterilerimizin taleplerini doğru analiz ederek, kaliteli ve ekonomik ürünler sunarak ihtiyaçlarını karşılamaktır.",
      },
      quickSolution: {
        title: "Hızlı Çözüm Üretme",
        description:
          "Müşterilerimizin karşılaşmış olduğu sorunları, tecrübe ve birikimlerimizden istifade ederek, en hızlı ve en etkin çözümleri üreterek sorunlarını gidermektir.",
      },
    },
  },
  viewStores: "Mağazalarımızı Görüntüle",

  footer: {
    description:
      "Akkuzey, müşterilerine kaliteli hizmet sunmayı, güvenilirliği ve sürdürülebilirliği ilke edinmiş bir şirkettir. Üretimde güçlü, çözümde hızlı, gelecekte daima var.",
    contactButton: "İletişim",
    corporate: {
      title: "Kurumsal",
      about: "Hakkımızda",
      contact: "İletişim",
      complaints: "İstek, Öneri, Şikayet Formu",
      faq: "Sık Sorulan Sorular",
    },
    quickMenu: {
      title: "Hızlı Menü",
    },
    map: {
      title: "Bizi Burada Bulabilirsiniz",
    },
    copyright: "© {{year}} Akkuzey Yapı Malzemeleri. Tüm hakları saklıdır.",
    contactInfo: {
      title: "İletişim Bilgileri",
      address: "Çırpıcı Mah. 75/2 Sk. No:109/1, Zeytinburnu / İstanbul",
      directions: "Yol tarifi al",
      weekdays: "Pzt – Cmt: 08:00 – 20:00",
      sunday: "Pazar: 11:00 – 18:30",
    },
    brandsStrip: {
      title: "Öne Çıkan Markalar",
      subtitle: "Bir markaya tıklayın, tüm ürünlerini görün.",
    },
    social: {
      whatsapp: "WhatsApp'tan yazın",
      instagram: "Instagram'da takip edin",
    },
  },
  faq: {
    title: "Sıkça Sorulan Sorular",
    subtitle:
      "Müşterilerimizin en çok merak ettiği konular hakkında bilgi edinin",
    contactPrompt: "Burada cevabını bulamadığınız sorularınız mı var?",
    contactButton: "İletişim Formuna Git",
    questions: {
      qualityStandards: {
        question: "Ürünleriniz hangi kalite standartlarına uygun?",
        answer:
          "Tüm ürünlerimiz Türk Standartları Enstitüsü (TSE) ve uluslararası kalite standartlarına uygun olarak seçilmektedir. Tedarikçilerimiz düzenli olarak denetlenir ve ürünlerimiz sıkı kalite kontrol süreçlerinden geçer.",
      },
      technicalSupport: {
        question: "Ürünleriniz için teknik destek alabilir miyim?",
        answer:
          "Evet, uzman ekibimiz ürünlerimizle ilgili teknik destek ve uygulama tavsiyeleri sunmaktadır. İhtiyacınız olan ürünle ilgili teknik bilgi için iletişim formumuzu doldurabilir veya doğrudan teknik destek hattımızı arayabilirsiniz.",
      },
      bulkSupply: {
        question: "Şantiyeme toplu malzeme temini yapıyor musunuz?",
        answer:
          "Evet, büyük ölçekli projeler için toplu malzeme temini ve özel fiyatlandırma seçenekleri sunuyoruz. Proje bazlı teklif almak için satış temsilcilerimizle iletişime geçebilirsiniz.",
      },
      productCatalogs: {
        question: "Ürün kataloglarınıza nasıl ulaşabilirim?",
        answer:
          "Güncel ürün kataloglarımıza web sitemizin 'Kataloglar' bölümünden ulaşabilir veya akkuzey@hotmail.com adresine mail atarak dijital kopya talep edebilirsiniz.",
      },
      customProduction: {
        question:
          "Farklı ölçü ve spesifikasyonlarda özel üretim yapıyor musunuz?",
        answer:
          "Evet, belirli ürün gruplarında müşteri ihtiyaçlarına yönelik özel ölçü ve spesifikasyonlarda üretim yapmaktayız. Detaylı bilgi için teknik destek ekibimizle iletişime geçebilirsiniz.",
      },
      training: {
        question: "Ürünleriniz için uygulama eğitimleri veriyor musunuz?",
        answer:
          "Profesyonel ekiplerimiz belirli periyotlarda ürün uygulama eğitimleri düzenlemektedir. Eğitim takvimimize web sitemizden ulaşabilir veya eğitim talepleriniz için bizimle iletişime geçebilirsiniz.",
      },
    },
  },
  complaintForm: {
    title: "ŞİKAYET & ÖNERİ FORMU",
    subtitle: "Geri bildirimleriniz bizim için değerli",
    fields: {
      name: "Ad Soyad",
      phone: "Telefon Numarası",
      orderNumber: "Sipariş Numarası",
      type: "Tür",
      message: "Mesajınız",
    },
    placeholders: {
      name: "Adınız ve soyadınız",
      phone: "5__ ___ __ __",
      orderNumber: "Sipariş numaranız",
      message: "Lütfen detaylı bir şekilde açıklayınız...",
    },
    types: {
      complaint: "Şikayet",
      suggestion: "Öneri",
      request: "Talep",
    },
    submit: "Gönder",
    submitting: "Gönderiliyor...",
    footerNote:
      "* İşaretli alanlar zorunludur. En kısa sürede size dönüş yapılacaktır.",
  },
  about: {
    title: "Hakkımızda",
    mainParagraph:
      "Akkuzey Yapı Malzemeleri San. ve Tic. Ltd. Şti., 1972 yılında İstanbul Zeytinburnu'nda kurulmuştur. Ticari hayatına nalburiye ürünlerinin toptan satışı ile başlayan firmamız, kuruluşundan bu yana dürüstlük, samimiyet ve müşteri memnuniyeti ilkelerinden ödün vermeden büyümesini sürdürmektedir.",
    corporateDevelopment: {
      title: "Kurumsal Gelişim",
      description:
        "Hırdavat ve nalburiye sektöründe ürün çeşitliliğini sürekli artıran Akkuzey, Ar-Ge çalışmalarıyla piyasa taleplerine yönelik çözümler üretmekte ve teknolojik altyapısını geliştirmektedir. Kurucumuz Sayın Adem Akkuzey liderliğinde, genç ve dinamik kadromuzla büyümeye devam etmekteyiz.",
    },
    futureVision: {
      title: "Gelecek Vizyonumuz",
      description:
        "Sektörümüzde kurumsallaşmayı ve zincir marka olmayı hedefleyen şirketimiz, yeni yatırımlar, güçlü insan kaynağı ve müşteri odaklı stratejilerle büyümesini sürdürüyor. Amacımız, gelecek nesillere sağlam temelli bir ticari yapı bırakmak.",
    },
    quote: {
      text: '"Kurucularımızdan aldığımız mirasla, gelecek nesillere kalıcı bir başarı hikâyesi bırakmak için azim ve kararlılıkla çalışıyoruz."',
      author: "Adem Akkuzey — Yönetim Kurulu Başkanı",
    },
  },
  contact: {
    title: "İletişim",
    subtitle:
      "Profesyonel ekibimiz, sorularınızı yanıtlamak ve projelerinizde size destek olmak için hazır.",

    offices: {
      headOffice: {
        title: "Merkez Ofis",
        address:
          "Çırpıcı Mah. 75/2 Sokak No:109/1\nZeytinburnu / İstanbul, Türkiye",
        phone1Label: "Tel 1",
        phone1: "0 (212) 415 45 11",
        phone2Label: "Tel 2",
        phone2: "0 (537) 798 11 29",
        emailLabel: "Email",
        email: "akkuzey@hotmail.com",
      },
      branch: {
        title: "Şube",
        address:
          "Beştelsiz Mah. 5. Yol Sokak No:7/A\nZeytinburnu / İstanbul, Türkiye",
        phoneLabel: "Tel",
        phone: "0 (212) 665 28 72",
      },
    },
    quickContact: {
      title: "Hızlı İletişim",
      phone: {
        label: "Müşteri Destek Hattı",
        number: "+90 212 415 45 11",
      },
      whatsapp: {
        label: "WhatsApp ile",
        action: "Mesaj Gönder",
      },
      email: {
        label: "Email Gönder",
        address: "akkuzey@hotmail.com",
      },
    },
  },
};

export default tr;
